import {createSlice} from "@reduxjs/toolkit";


const initialReceiptTrackingState = {
    listLoading: false,
    pdfReportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    sortedReceiptsTotal: 0,
    entities: [],
    sortedReceipts: [],
    masterReceipts: [],
    totalMasterReceipts: 0,
    pdfReceiptReportStr: "",
    receiptsMaxLimit: false,
    receiptMaxErrorMsg: "",
    receiptForEdit: undefined,
    error: null
  };

  export const callTypes = {
    list: "list",
    action: "action",
    report: "report"
  };
  

const receiptTrackingSlice = createSlice({
    name: 'receiptTracking',
    initialState:initialReceiptTrackingState,
    reducers: {
        catchError: (state, action) => {
          state.error = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else if (action.payload.callType === callTypes.report) {
            state.pdfReportLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.error = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else if (action.payload.callType === callTypes.report) {
            state.pdfReportLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        // getReceiptById
        receiptFetched: (state, action) => {
          state.actionsLoading = false;
          state.recieptForEdit = action.payload.receiptForEdit;
          state.error = null;
        },
        // findReceipts
        receiptsFetched: (state, action) => {
          const { totalCount, entities } = action.payload;
          state.entities = entities;
          state.totalCount = totalCount;
          state.listLoading = false;
          state.error = null;
        },
        masterReceiptsFetched: (state, action) => {
          const { totalCount, entities } = action.payload;
          state.masterReceipts = entities;
          state.totalMasterReceipts = totalCount;
          state.listLoading = false;
          state.error = null;
        },
        sortedReceiptsFetched: (state, action) => {
          const { totalCount, entities } = action.payload;
          state.sortedReceipts = entities;
          state.entities = entities;
          state.sortedReceiptsTotal = totalCount;
          state.listLoading = false;
          state.error = null;
        },
        receiptsReportFetched: (state, action) => {
          const { dataString } = action.payload;
          state.pdfReceiptReportStr = dataString;
          state.pdfReportLoading = false;
          state.error = null;
        },
        receiptMaxLimitReached: (state, action) => {
          const { msg } = action.payload;
          state.listLoading = false;
          state.entities = [];
          state.sortedReceipts = [];
          state.error = null;
          state.receiptsMaxLimit = true;
          state.receiptMaxErrorMsg = msg;
        },
        clearReceiptMaxLimit: (state, action) => {
          state.receiptsMaxLimit = false;
          state.receiptMaxErrorMsg = "";
        },
        clearReportString: (state, action) => {
          state.pdfReceiptReportStr = "";
        },
        // receiptCreated
        receiptCreated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          state.entities.push(action.payload.receipt);
        },
        // updateReceipt
        receiptUpdated: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.map(entity => {
            if (entity.id === action.payload.receipt.id) {
              return action.payload.receipt;
            }
            return entity;
          });
        },
        // deleteReceipt
        receiptDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(el => el.id !== action.payload.id);
        },
        // deleteReceipts
        receiptsDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(
            el => !action.payload.ids.includes(el.id)
          );
        },
        // receiptsUpdateState
        receiptStatusUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, status } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.status = status;
            }
            //changes earch entity in the array
            return entity;
          });
        }
      }
});

export const {actions} = receiptTrackingSlice;
export const {reducer} = receiptTrackingSlice;